module.exports = __webpack_public_path__ + "img/twitter.7a4236a4.svg";